import React, { Fragment, useEffect, useRef, useState } from "react";
import PageHeader from "../../common/components/PageHeader";
import { Box, Checkbox, Divider, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, InputAdornment, Menu, MenuItem, TextField, Typography, useTheme, useMediaQuery } from "@mui/material";
import CommonCard from "../../common/components/CommonCard";
import CommonButton from "../../common/components/CommonButton";
import CommonDialog from "../../common/components/CommonDialog";
import CommonFormField from "../../common/components/CommonFormField";
import Badge from "../../common/components/Badge";
import { Add, Check, Close, Search } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import { setLoading } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { createWishList, getAiSuggestCollege, getCollegeList, getWishListCollege, updateWishList } from "../../api/collegeApi";
import { useLocation, useNavigate } from "react-router-dom";
import CommonSelect from "../../common/components/CommonSelect";
import { getCountries } from "../../api/authApi";
import { UserTypeId } from '../../common/const';

const options = [
  { label: 'Dream', value: 'DREAM' },
  { label: 'Safe', value: 'SAFE' },
  { label: 'Target', value: 'TARGET' }
];

const CollegeList = () => {
  const theme = useTheme();
  const scrollRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, loading } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  // Responsive breakpoints
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isFetchingMore, setIsFetchingMore] = useState(false);
  const [countryArr, setCountryArr] = useState([]);
  const [totals, setTotals] = useState(0);
  const page = 1;
  const pagesize = 250;
  const [selectOption, setSelectOption] = useState('explore');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [collegeOpen, setCollegeOpen] = useState(false);
  const [selectedCollege, setSelectedCollege] = useState(null);
  const [changeCollegeOpen, setChangeCollegeOpen] = useState(false);
  const [formData, setFormData] = useState({
    collegename: '',
    city: '',
    state: '',
    country: '',
    categories: []
  });
  const [filterApplied, setFilterApplied] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [wishlistCollege, setWishListCollege] = useState([]);
  const [colleges, setColleges] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [wishListType, setWishListType] = useState(null);
  const [collegeId, setCollegeId] = useState(null);

  const handleAddMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAddMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChangeMenuOpen = (event) => {
    setAnchorE2(event.currentTarget);
  };

  const handleChangeMenuClose = () => {
    setAnchorE2(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getAllWishListColleges = async () => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await getWishListCollege(user?.student_id);
      if (response.data.length > 0) {
        setWishListCollege(response.data);
      } else {
        setWishListCollege([]);
      }
      dispatch(setLoading({
        loading: false
      }));
    } catch (err) {
      setWishListCollege([]);
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      if (errorMessage !== 'College not found') {
        showNotification(errorMessage, 'error');
      }
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  useEffect(() => {
    if (user?.student_id) {
      getAllWishListColleges();
    }
  }, [user?.student_id, location.search?.split('=')?.[1]]);

  const getAiSuggestColleges = async () => {
    try {
      dispatch(setLoading({ loading: true }));
      const response = await getAiSuggestCollege(user?.student_id);
      const newData = response.data.data || [];
      setColleges(prev =>
        pageNo === 1 ? newData : [...prev, ...newData]
      );
      dispatch(setLoading({ loading: false }));
    } catch (err) {
      dispatch(setLoading({ loading: false }));
      const errorMessage =
        err.response?.data?.errors?.[0]?.message ||
        err.response?.data?.message ||
        err?.response?.data?.error;

      if (errorMessage !== 'College not found') {
        showNotification(errorMessage, 'error');
      }
    }
  };

  useEffect(() => {
    if (user?.student_id) {
      if (selectOption === 'explore') {
        getAllColleges();
      } else if (selectOption === 'aigenerated') {
        setPageNo(1);
        setColleges([]);
        getAiSuggestColleges();
      }
    }
  }, [user?.student_id, location.search?.split('=')?.[1], pageNo, selectOption]);

  const setWishList = async () => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await createWishList({
        "student_id": user?.student_id,
        "college_id": collegeId,
        "list_type": wishListType,
      });
      if (response.success) {
        showNotification(`College added to ${wishListType.charAt(0).toUpperCase() + wishListType.slice(1).toLowerCase()} List`, 'success');
        setCollegeId(null);
        setWishListType(null);
        if (selectOption === 'explore') {
          getAllColleges();
        } else if (selectOption === 'aigenerated') {
          getAiSuggestColleges();
        }
        getAllWishListColleges();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  const updateWishLists = async () => {
    try {
      dispatch(setLoading({
        loading: true
      }));
      const response = await updateWishList(selectedCollege?.student_college_id, {
        "student_id": user?.student_id,
        "college_id": selectedCollege?.college_id,
        "list_type": wishListType,
      });
      if (response.success) {
        showNotification(`College updated to ${wishListType.charAt(0).toUpperCase() + wishListType.slice(1).toLowerCase()} List`, 'success');
        setCollegeId(null);
        setWishListType(null);
        getAllColleges();
        setSelectedCollege(null);
        getAllWishListColleges();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
      showNotification(errorMessage, 'error');
      dispatch(setLoading({
        loading: false
      }));
    }
  };

  useEffect(() => {
    if (collegeId !== null && wishListType !== null) {
      setWishList();
    } else if (selectedCollege?.student_college_id) {
      updateWishLists();
    }
  }, [collegeId, wishListType]);

  const getCountry = async (page) => {
    const response = await getCountries(page, pagesize);
    setCountryArr(response.countries.map((a) => ({
      label: a.name,
      value: a.country_id
    })));
    dispatch(setLoading({
      loading: false
    }));
  }

  useEffect(() => {
    dispatch(setLoading({
      loading: true
    }));
    getCountry(page);
  }, []);

  // Replacement for getAllColleges and resetFiltersAndFetch only.
  // Drop these two functions in over the existing ones in CollegeList.jsx.
  // Nothing else in the file needs to change.

  const getAllColleges = async () => {
    try {
      if (pageNo > 1) {
        setIsFetchingMore(true);
      } else {
        dispatch(setLoading({ loading: true }));
      }

      let filter = {};
      const conditions = [
        { key: 'college_name', value: formData.collegename },
        { key: 'city', value: formData.city },
        { key: 'state', value: formData.state },
        { key: 'country_id', value: formData.country },
        {
          key: 'list_type',
          value: formData.categories.length > 0
            ? formData.categories.toString()
            : null,
        },
      ];

      let hasFilter = false;
      conditions.forEach(({ key, value }) => {
        if (value) {
          filter[key] = value;
          hasFilter = true;
        }
      });
      setFilterApplied(hasFilter);

      const response = await getCollegeList(
        user?.student_id,
        pageNo,
        pagesize,
        searchText
        ?? new URLSearchParams(location.search).get('search')
        ?? '',
        JSON.stringify(filter),
      );
      const newData = response.data.data || [];

      if (newData.length === 0) {
        // No results on this page.
        //  • Page 1: show empty state ("No College Found" handles the UI).
        //    Clear any leftover list from a previous search.
        //  • Page 2+: end of pagination — keep the already-loaded list
        //    intact and just stop the loader.
        // Either way: NOT an error, NO notification.
        setHasMore(false);
        if (pageNo === 1) {
          setColleges([]);
          setTotals(0);
        }
      } else {
        setColleges((prev) =>
          pageNo === 1 ? newData : [...prev, ...newData],
        );
        setTotals(response?.data?.pagination?.total ?? 0);
      }

      dispatch(setLoading({ loading: false }));
      setIsFetchingMore(false);
    } catch (err) {
      setIsFetchingMore(false);
      dispatch(setLoading({ loading: false }));

      // Real API failure (network, 5xx, etc.).
      //  • Page 1: wipe colleges so the user sees the empty state.
      //  • Page 2+: keep the colleges already loaded so the user doesn't
      //    lose their list because of a scroll-triggered request failure.
      if (pageNo === 1) {
        setColleges([]);
        setTotals(0);
      }

      const errorMessage =
        err.response?.data?.errors?.[0]?.message
        || err.response?.data?.message
        || err?.response?.data?.error;

      if (errorMessage !== 'College not found') {
        showNotification(errorMessage, 'error');
      }
    }
  };


  const resetFiltersAndFetch = () => {
    setFormData({
      collegename: '',
      city: '',
      state: '',
      country: '',
      categories: [],
    });

    const fetchWithEmptyFilters = async () => {
      try {
        dispatch(setLoading({ loading: true }));
        setFilterApplied(false);

        const response = await getCollegeList(
          user?.student_id,
          pageNo,
          pagesize,
          '',
          JSON.stringify({}),
        );

        const data = response?.data?.data || [];
        if (data.length > 0) {
          setColleges(data);
          setTotals(response?.data?.pagination?.total ?? data.length);
        } else {
          // Empty result on reset: clear list, show empty state, no toast.
          setColleges([]);
          setTotals(0);
        }
        dispatch(setLoading({ loading: false }));
      } catch (err) {
        // Real error: clear and surface the message (only if present).
        setColleges([]);
        setTotals(0);
        const errorMessage =
          err.response?.data?.errors?.[0]?.message
          || err.response?.data?.message
          || err?.response?.data?.error;
        if (errorMessage) {
          showNotification(errorMessage, 'error');
        }
        dispatch(setLoading({ loading: false }));
      }
    };

    fetchWithEmptyFilters();
  };

  const getScrollHeight = () => {
    if (selectOption === 'aigenerated') {
      if (isMobile) return '50vh';
      if (isTablet) return '48vh';
      return '44vh';
    }
    if (isMobile) return '65vh';
    if (isTablet) return '62vh';
    return '57vh';
  };

  return (
    <Fragment>
      {(loading || isFetchingMore) && (
        <LoadingSpinner />
      )}

      {/* Change College Dialog */}
      <CommonDialog
        open={changeCollegeOpen}
        size={isMobile ? "full" : "md"}
        padding="0px"
        title={
          <Fragment>
            <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ padding: '10px 15px' }}>
              <Box>
                <Typography sx={{ fontWeight: 600, fontSize: { xs: 14, sm: 16 } }}>Change College</Typography>
                <Typography fontSize={{ xs: 12, sm: 13 }} color={theme.palette.background.dark}>You can update your college</Typography>
              </Box>
              <Close
                sx={{
                  color: theme.palette.background.dark,
                  fontSize: { xs: 18, sm: 20 },
                  float: 'right',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setChangeCollegeOpen(false);
                }}
              />
            </Box>
            <Divider />
          </Fragment>
        }
        content={
          <Box sx={{ maxHeight: '60vh', overflow: 'auto', px: { xs: 1, sm: 2 } }}>
            {wishlistCollege.map((a, index) => (
              <Grid key={index} item xs={12} mt={1} sx={{ cursor: 'pointer' }}>
                <CommonCard
                  paddingBottom="0px"
                  padding={{ xs: "10px", sm: "13px" }}
                  borderRadius={2}
                  border={`1px solid ${theme.palette.background.secondary}`}
                  marginTop="0px"
                  content={
                    <Grid container spacing={{ xs: 1, sm: 2 }}>
                      <Grid item xs={12} sm={3}>
                        <img
                          src={a?.college?.logo_url || '/Images/college_1.png'}
                          alt="college"
                          style={{
                            width: '100%',
                            aspectRatio: 1,
                            borderRadius: 10
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Box display="flex" justifyContent="space-between" flexDirection={{ xs: 'column', sm: 'row' }}>
                          <Box>
                            <Typography fontWeight={600} fontSize={{ xs: 14, sm: 16 }}>{a?.college?.college_name}</Typography>
                            <Box display="flex" gap={0.3} alignItems='center'>
                              <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                              <Typography fontSize={{ xs: 12, sm: 14 }} color={theme.palette.background.dark}>{`${a?.college?.city}, ${a?.college?.state} ${a?.college?.zipcode}`}</Typography>
                            </Box>
                          </Box>
                          <Box mt={{ xs: 1, sm: 0 }}>
                            {user?.user_type_id === UserTypeId.Student && (
                              <CommonButton
                                label="Add"
                                fontWeight="bold"
                                color={theme.palette.primary.main}
                                background={theme.palette.secondary.main}
                                height="30px"
                                startIcon={<Add sx={{ color: 'white' }} />}
                                handleClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setSelectedCollege(a);
                                  handleChangeMenuOpen(e);
                                }}
                              />
                            )}
                            <Menu
                              anchorEl={anchorE2}
                              open={Boolean(anchorE2)}
                              onClose={handleChangeMenuClose}
                              PaperProps={{
                                sx: {
                                  width: '80px',
                                  borderRadius: 0,
                                  boxShadow: 'none',
                                  background: theme.palette.background.main,
                                }
                              }}
                              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                              <MenuItem
                                sx={{ fontSize: 13, fontWeight: 600, padding: '5px 20px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setWishListType('SAFE');
                                  handleChangeMenuClose();
                                }}
                              >
                                Safe
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: 13, fontWeight: 600, padding: '5px 20px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setWishListType('DREAM');
                                  handleChangeMenuClose();
                                }}
                              >
                                Dream
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: 13, fontWeight: 600, padding: '5px 20px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setWishListType('TARGET');
                                  handleChangeMenuClose();
                                }}
                              >
                                Target
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        <Grid container spacing={1} mt={0.5}>
                          <Grid item xs={6} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a?.college?.overall_college_grade || 'Unavailable'}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Overall Grade</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a?.college?.acceptance_rate ? `${a?.college?.acceptance_rate} %` : '-'}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Acceptance Rate</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a?.college?.annual_net_cost ? `$ ${a?.college?.annual_net_cost} per year` : 0}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Annual Net Cost</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={6} sm={5}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a?.college?.yearly_student_graduate_count || 0}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Total Undergraduate Students</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a?.college?.website || '-'}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Website</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  }
                />
              </Grid>
            ))}
          </Box>
        }
      />

      {/* Filter Dialog */}
      <CommonDialog
        open={dialogOpen}
        size={isMobile ? "full" : "xs"}
        title={
          <Fragment>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography sx={{ fontWeight: 600, fontSize: { xs: 16, sm: 18 } }}>Filter College</Typography>
              <Close
                sx={{
                  color: theme.palette.background.dark,
                  fontSize: { xs: 18, sm: 20 },
                  float: 'right',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  setDialogOpen(false);
                }}
              />
            </Box>
            <Divider />
          </Fragment>
        }
        content={
          <Grid container spacing={1.5} mt={1} mb={2}>
            <Grid item xs={12}>
              <CommonFormField
                label="College Name"
                type="email"
                name="collegename"
                value={formData.collegename}
                onChange={handleInputChange}
                placeholder="Enter College Name"
              />
            </Grid>
            <Grid item xs={12}>
              <CommonFormField
                label="City"
                type="email"
                name="city"
                value={formData.city}
                onChange={handleInputChange}
                placeholder="Enter City"
              />
            </Grid>
            <Grid item xs={12}>
              <CommonFormField
                label="State"
                type="email"
                name="state"
                value={formData.state}
                onChange={handleInputChange}
                placeholder="Enter State"
              />
            </Grid>
            <Grid item xs={12}>
              <CommonSelect
                label="Country"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                placeholder="Select country"
                options={countryArr}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  sx={{
                    fontSize: 14,
                    color: theme.palette.text.main,
                    '&.Mui-focused': {
                      color: theme.palette.text.main,
                    }
                  }}>
                  Choose Options
                </FormLabel>
                <FormGroup row>
                  {options.map((option) => (
                    <FormControlLabel
                      key={option.value}
                      sx={{
                        color: theme.palette.background.dark
                      }}
                      control={
                        <Checkbox
                          checked={formData.categories.includes(option.value)}
                          onChange={(event) => {
                            const { value, checked } = event.target;
                            setFormData(prev => ({
                              ...prev,
                              categories: checked
                                ? [...prev.categories, value]
                                : prev.categories.filter(item => item !== value)
                            }));
                          }}
                          value={option.value}
                        />
                      }
                      label={option.label}
                    />
                  ))}
                </FormGroup>
              </FormControl>
            </Grid>
          </Grid>
        }
        actionButtons={(
          <CommonButton
            label="Apply"
            size="small"
            background={theme.palette.secondary.main}
            color={theme.palette.background.main}
            fontWeight={700}
            marginBottom="10px"
            handleClick={() => {
              localStorage.removeItem('college_search');
              navigate('/colleges');
              getAllColleges();
              setDialogOpen(false);
            }}
          />
        )}
      />

      {/* College Detail Dialog */}
      <CommonDialog
        open={collegeOpen}
        size={isMobile ? "full" : "md"}
        title={
          <Close
            sx={{
              color: theme.palette.background.dark,
              fontSize: { xs: 18, sm: 20 },
              float: 'right',
              cursor: 'pointer'
            }}
            onClick={() => {
              setCollegeOpen(false);
              setSelectedCollege(null);
            }}
          />
        }
        padding={{ xs: "10px", sm: "10px 10px 0px 10px" }}
        content={
          <Fragment>
            {selectedCollege && (
              <>
                <Grid container spacing={{ xs: 2, sm: 3 }}>
                  <Grid item xs={12} sm={4}>
                    <img
                      src={selectedCollege?.logo_url || '/Images/college_1.png'}
                      alt="college"
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '270px',
                        objectFit: 'cover',
                        borderRadius: 10
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Box display="flex" justifyContent="space-between" flexDirection={{ xs: 'column', sm: 'row' }}>
                      <Box>
                        <Typography fontWeight={600} fontSize={{ xs: 16, sm: 18 }}>{selectedCollege?.college_name}</Typography>
                        <Box display="flex" gap={0.3} alignItems='center'>
                          <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                          <Typography fontSize={{ xs: 12, sm: 14 }} color={theme.palette.background.dark}>{`${selectedCollege?.city}, ${selectedCollege?.state} ${selectedCollege?.zipcode}`}</Typography>
                        </Box>
                      </Box>
                      <Box display='flex' gap={1} mt={{ xs: 1, sm: 0 }}>
                        {selectedCollege?.studentCollegeLists?.find((a) => a.list_type === 'DREAM') ? (
                          <Badge
                            text="Dream"
                            color={theme.palette.secondary.main}
                            background={theme.palette.primary.main}
                            fontWeight={'bold'}
                          />
                        ) : selectedCollege?.studentCollegeLists?.find((a) => a.list_type === 'SAFE') ? (
                          <Badge
                            text="Safe"
                            color={theme.palette.primary.main}
                            background={theme.palette.secondary.main}
                            fontWeight={'bold'}
                          />
                        ) : selectedCollege?.studentCollegeLists?.find((a) => a.list_type === 'TARGET') ? (
                          <Badge
                            text="Target"
                            color={theme.palette.secondary.main}
                            background={theme.palette.secondary.default}
                            fontWeight={'bold'}
                          />
                        ) : ''}
                        {selectedCollege?.studentCollegeLists?.find((a) => ['DREAM', 'TARGET', 'SAFE'].includes(a.list_type)) && (
                          <CommonButton
                            label="Added"
                            fontWeight="bold"
                            border={`1px solid ${theme.palette.secondary.main}`}
                            color={theme.palette.secondary.main}
                            background={'white'}
                            height="30px"
                            startIcon={<Check />}
                          />
                        )}
                      </Box>
                    </Box>
                    <Grid container spacing={1} mt={0.5}>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          borderRadius={1}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.overall_college_grade || 'Unavailable'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Overall Grade</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          borderRadius={1}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.acceptance_rate ? `${selectedCollege?.acceptance_rate} %` : '-'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Acceptance Rate</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          borderRadius={1}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.annual_net_cost ? `$ ${selectedCollege?.annual_net_cost} per year` : 0}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Annual Net Cost</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          borderRadius={1}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.yearly_student_graduate_count || 0}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Total Undergraduate Students</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          borderRadius={1}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.website || '-'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Website</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                    </Grid>
                    <Box mt={1}>
                      <Typography fontSize={{ xs: 13, sm: 14 }} fontWeight="600">About the college</Typography>
                      <Typography fontSize={{ xs: 12, sm: 14 }} color={theme.palette.background.dark}>{selectedCollege?.college_description}</Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={1}>
                  <Grid item xs={12} sm={3}>
                    <CommonCard
                      background="#ECEBEB"
                      paddingBottom="0px"
                      padding={{ xs: "15px", sm: "21px" }}
                      marginTop="5px"
                      content={
                        <Box>
                          <Typography fontSize={{ xs: 28, sm: 35 }} fontWeight="800" textAlign="center">{selectedCollege?.overall_college_grade || 'Unavailable'}</Typography>
                          <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark} textAlign="center">Overall Niche Grade</Typography>
                        </Box>
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={9}>
                    <Grid container spacing={1}>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.overall_academics_rating || 'Unavailable'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Academic</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.overall_value_rating || 'Unavailable'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Value</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.diversity || 'Unavailable'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Diversity</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.campus || 'Unavailable'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Campus</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.diversity || 'Unavailable'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Athletic</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                      <Grid item xs={6} sm={4}>
                        <CommonCard
                          background={theme.palette.background.main}
                          paddingBottom="0px"
                          padding={{ xs: "3px 8px", sm: "5px 13px" }}
                          marginTop="5px"
                          content={
                            <Box>
                              <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{selectedCollege?.party_score || 'Unavailable'}</Typography>
                              <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Party Scene</Typography>
                            </Box>
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}
          </Fragment>
        }
      />

      {/* Page Header */}
      <PageHeader
        title="My DCP College List"
        content={
          <Typography color="text.secondary" sx={{ fontSize: { xs: 12, sm: 14 } }}>
            Search, organize, and manage your college wishlist
          </Typography>
        }
        color={theme.palette.secondary.main}
      />

      {/* Main Card with Search and Filters */}
      <CommonCard
        paddingBottom="0px"
        padding={{ xs: "12px", sm: "16px" }}
        marginTop="15px"
        borderRadius={2}
        content={
          <Box
            display="flex"
            flexDirection={{ xs: 'column', md: 'row' }}
            justifyContent="space-between"
            gap={2}
          >
            <Box
              display="flex"
              gap={1}
              width={{ xs: '100%', md: '50%' }}
              flexDirection={{ xs: 'column', sm: 'row' }}
            >
              <CommonButton
                label="Explore Colleges"
                marginBottom="0px"
                width={{ xs: '100%', sm: '160px' }}
                background={selectOption === 'explore' ? theme.palette.primary.main : theme.palette.background.main}
                color={selectOption === 'explore' ? theme.palette.secondary.main : theme.palette.background.dark}
                fontWeight={selectOption === 'explore' ? 600 : 100}
                handleClick={() => setSelectOption('explore')}
              />
              <CommonButton
                label="AI-Powered College Recommendations"
                marginBottom="0px"
                width={{ xs: '100%', sm: '310px' }}
                background={selectOption === 'aigenerated' ? theme.palette.primary.main : theme.palette.background.main}
                color={selectOption === 'aigenerated' ? theme.palette.secondary.main : theme.palette.background.dark}
                fontWeight={selectOption === 'aigenerated' ? 600 : 100}
                handleClick={() => setSelectOption('aigenerated')}
              />
            </Box>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              width: { xs: '100%', md: '70%' },
              justifyContent: { xs: 'flex-start', md: 'flex-end' },
              flexWrap: 'wrap'
            }}>
              <TextField
                placeholder="Search with Name, State & Country"
                variant="outlined"
                size="small"
                sx={{
                  flex: { xs: '1 1 auto', sm: '0 1 auto' },
                  '& .MuiOutlinedInput-root': {
                    background: theme.palette.background.main,
                    '& fieldset': {
                      border: 'none',
                    },
                    '&:hover fieldset': {
                      border: 'none',
                    },
                    '&.Mui-focused fieldset': {
                      border: 'none'
                    },
                  },
                  '& input': {
                    height: { xs: '20px', sm: '25px' },
                    fontSize: { xs: '14px', sm: '16px' },
                    fontWeight: 500,
                    width: { xs: '100%', sm: '280px' }
                  }
                }}
                onChange={(e) => {
                  localStorage.removeItem('college_search');
                  setSearchText(e.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search sx={{ fontSize: { xs: 24, sm: 30 }, color: theme.palette.background.dark }} />
                    </InputAdornment>
                  ),
                }}
              />
              {filterApplied ? (
                <CommonButton
                  label="Reset Filters"
                  marginBottom="0px"
                  width={{ xs: 'auto', sm: '150px' }}
                  fontWeight={500}
                  background={theme.palette.background.main}
                  border={`1px solid ${theme.palette.background.secondary}`}
                  startIcon={<img src="/Images/Filter.png" alt="Filter" />}
                  color="black"
                  handleClick={() => {
                    localStorage.removeItem('college_search');
                    navigate('/colleges');
                    resetFiltersAndFetch();
                  }}
                />
              ) : (
                <CommonButton
                  label="Filters"
                  marginBottom="0px"
                  width={{ xs: 'auto', sm: '120px' }}
                  fontWeight={500}
                  background={theme.palette.background.main}
                  border={`1px solid ${theme.palette.background.secondary}`}
                  startIcon={<img src="/Images/Filter.png" alt="Filter" />}
                  color="black"
                  handleClick={() => setDialogOpen(true)}
                />
              )}
              <CommonButton
                label="Search"
                marginBottom="0px"
                width={{ xs: 'auto', sm: '120px' }}
                fontWeight={600}
                background={theme.palette.secondary.main}
                color="White"
                handleClick={() => {
                  setPageNo(1);
                  setHasMore(true);
                  setColleges([]);
                  localStorage.removeItem('college_search');
                  navigate('/colleges');
                  getAllColleges();
                }}
              />
            </Box>
          </Box>
        }
      />

      {/* AI Recommendations Banner */}
      {selectOption === 'aigenerated' && (
        <Box
          sx={{
            background: theme.palette.cardbackground.secondary,
            padding: { xs: '15px', sm: '20px' },
            borderRadius: 1,
            mt: 2,
            border: `1px solid ${theme.palette.cardbackground.main}`
          }}
        >
          <Box
            display="flex"
            gap={1}
            alignItems="center"
            flexDirection={{ xs: 'column', sm: 'row' }}
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            <img src="/Images/AIIcon.png" alt="AI" height="40px" />
            <Box>
              <Typography fontWeight={600} fontSize={{ xs: 16, sm: 18 }}>AI-Powered College Recommendations</Typography>
              <Typography fontSize={{ xs: 12, sm: 14 }} color={theme.palette.background.dark}>Based on your profile and test scores</Typography>
            </Box>
          </Box>
        </Box>
      )}

      {/* Results Count */}
      <Typography mt={2} mb={2} fontWeight={600} fontSize={{ xs: 14, sm: 16 }}>
        {selectOption === 'explore' ? totals : colleges.length} colleges found
      </Typography>

      {/* Colleges Grid */}
      <Box
        ref={scrollRef}
        onScroll={(e) => {
          if (selectOption !== 'aigenerated') {
            const { scrollTop, scrollHeight, clientHeight } = e.target;
            const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;
            if (isNearBottom && !isFetchingMore && hasMore) {
              setIsFetchingMore(true);
              setPageNo(prev => prev + 1);
            }
          }
        }}
        sx={{
          height: getScrollHeight(),
          overflow: 'auto'
        }}
      >
        {colleges.length > 0 ? (
          <Grid container spacing={2}>
            {colleges.map((a, index) => (
              <Grid key={index} item xs={12} lg={6} sx={{ cursor: 'pointer' }} onClick={(e) => {
                e.preventDefault();
                setCollegeOpen(true);
                setSelectedCollege(a);
              }}>
                <CommonCard
                  paddingBottom="0px"
                  padding={{ xs: "10px", sm: "13px" }}
                  borderRadius={2}
                  marginTop="0px"
                  content={
                    <Grid container spacing={{ xs: 1, sm: 2 }}>
                      <Grid item xs={12} sm={3}>
                        <img
                          src={a.logo_url || '/Images/college_1.png'}
                          alt="college"
                          style={{
                            width: '100%',
                            aspectRatio: 1,
                            borderRadius: 10
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <Box display="flex" justifyContent="space-between" flexDirection={{ xs: 'column', sm: 'row' }}>
                          <Box>
                            <Typography fontWeight={600} fontSize={{ xs: 14, sm: 16 }}>{a.college_name}</Typography>
                            <Box display="flex" gap={0.3} alignItems='center'>
                              <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                              <Typography fontSize={{ xs: 12, sm: 14 }} color={theme.palette.background.dark}>{`${a?.city}, ${a?.state} ${a?.zipcode}`}</Typography>
                            </Box>
                          </Box>
                          <Box
                            display="flex"
                            gap={1}
                            mt={{ xs: 1, sm: 0 }}
                          >
                            {((a?.studentCollegeLists?.find((a) => a.list_type === 'DREAM')) || (user?.indexScore > 90 && selectOption === 'aigenerated')) ? (
                              <Badge
                                text="Dream"
                                color={theme.palette.secondary.main}
                                background={theme.palette.primary.main}
                                fontWeight={'bold'}
                                handleClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                              />
                            ) : ((a?.studentCollegeLists?.find((a) => a.list_type === 'SAFE')) || ((user?.indexScore >= 60 || user?.indexScore <= 90) && selectOption === 'aigenerated')) ? (
                              <Badge
                                text="Safe"
                                color={theme.palette.primary.main}
                                background={theme.palette.secondary.main}
                                fontWeight={'bold'}
                                handleClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                              />
                            ) : ((a?.studentCollegeLists?.find((a) => a.list_type === 'TARGET')) || (user?.indexScore < 60 && selectOption === 'aigenerated')) ? (
                              <Badge
                                text="Target"
                                color={theme.palette.secondary.main}
                                background={theme.palette.secondary.default}
                                fontWeight={'bold'}
                                handleClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                              />
                            ) : ''}

                            {user?.user_type_id === UserTypeId.Student && a?.studentCollegeLists?.find((a) => ['DREAM', 'SAFE', 'TARGET'].includes(a.list_type)) ? (
                              <CommonButton
                                label="Change"
                                fontWeight="bold"
                                border={`1px solid ${theme.palette.secondary.main}`}
                                color={theme.palette.secondary.main}
                                background={'white'}
                                height="30px"
                                startIcon={<Check sx={{ color: theme.palette.secondary.main }} />}
                                handleClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setChangeCollegeOpen(true)
                                }}
                              />
                            ) : user?.user_type_id === UserTypeId.Student && (
                              <CommonButton
                                label="Add"
                                fontWeight="bold"
                                color={theme.palette.primary.main}
                                background={theme.palette.secondary.main}
                                height="30px"
                                startIcon={<Add sx={{ color: 'white' }} />}
                                handleClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  setCollegeId(a.college_id);
                                  handleAddMenuOpen(e);
                                }}
                              />
                            )}
                            <Menu
                              anchorEl={anchorEl}
                              open={Boolean(anchorEl)}
                              onClose={handleAddMenuClose}
                              PaperProps={{
                                sx: {
                                  width: '80px',
                                  borderRadius: 0,
                                  boxShadow: 'none',
                                  background: theme.palette.background.main,
                                }
                              }}
                              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                            >
                              <MenuItem
                                sx={{ fontSize: 13, fontWeight: 600, padding: '5px 20px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setWishListType('SAFE');
                                  handleAddMenuClose();
                                }}
                              >
                                Safe
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: 13, fontWeight: 600, padding: '5px 20px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddMenuClose();
                                  setWishListType('DREAM');
                                }}
                              >
                                Dream
                              </MenuItem>
                              <MenuItem
                                sx={{ fontSize: 13, fontWeight: 600, padding: '5px 20px' }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleAddMenuClose();
                                  setWishListType('TARGET');
                                }}
                              >
                                Target
                              </MenuItem>
                            </Menu>
                          </Box>
                        </Box>
                        <Grid container spacing={1}>
                          <Grid item xs={6} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a.overall_college_grade || 'Unavailable'}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Overall Grade</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a.acceptance_rate ? `${a.acceptance_rate} %` : 0}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Acceptance Rate</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a.annual_net_cost ? `$ ${a.annual_net_cost} per year` : '-'}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Annual Net Cost</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={6} sm={5}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a.yearly_student_graduate_count || 0}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Total Undergraduate Students</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                          <Grid item xs={6} sm={4}>
                            <CommonCard
                              background={theme.palette.background.main}
                              borderRadius={1}
                              paddingBottom="0px"
                              padding={{ xs: "3px 8px", sm: "5px 13px" }}
                              marginTop="5px"
                              content={
                                <Box sx={{ wordBreak: 'break-all' }}>
                                  <Typography fontSize={{ xs: 12, sm: 14 }} fontWeight="600">{a.website || '-'}</Typography>
                                  <Typography fontSize={{ xs: 11, sm: 13 }} color={theme.palette.background.dark}>Website</Typography>
                                </Box>
                              }
                            />
                          </Grid>
                        </Grid>
                        {selectOption === 'aigenerated' && (
                          <Box sx={{ float: 'right', mt: 1 }}>
                            <CommonButton
                              marginTop={2}
                              height="30px"
                              marginBottom="-10px"
                              label="Recommended by DCP AI"
                              width={{ xs: "180px", sm: "200px" }}
                              fontSize="15px"
                              fontWeight={600}
                            />
                          </Box>
                        )}
                      </Grid>
                    </Grid>
                  }
                />
              </Grid>
            ))}
          </Grid>
        ) : (
          <Box
            display="flex"
            justifyContent="center"
            mt={2}
            ml={2}
          >
            <Typography color={theme.palette.background.dark}>No College Found</Typography>
          </Box>
        )}
      </Box>
    </Fragment>
  );
};

export default CollegeList;